// extracted by mini-css-extract-plugin
export default {"cls1":"SU5w5oCKYUJmAdCUP21F","cls2":"JSnSDS8RbBzpmnQmB7eV SU5w5oCKYUJmAdCUP21F"};